import { ArrowRight } from "lucide-react";
import { useTranslation } from "@/i18n/useTranslation";

interface CTABannerProps {
  variant?: "light" | "dark";
  headline: string;
  description: string;
}

const CTABanner = ({ variant = "light", headline, description }: CTABannerProps) => {
  const { t } = useTranslation();
  const isDark = variant === "dark";

  return (
    <section className={`${isDark ? "section-dark grain" : "bg-card"} relative ambient-glow`}>
      <div className="shimmer-line" />

      <div className="container-narrow section-cinematic relative z-10">
        <div className="text-center">
          {/* Subtle radial glow */}
          {isDark && (
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[350px] h-[350px] rounded-full pointer-events-none"
              style={{ background: "radial-gradient(circle, hsl(var(--primary) / 0.05) 0%, transparent 70%)" }}
            />
          )}
          <h2 className={`heading-statement mb-8 relative z-10 ${isDark ? "text-[hsl(var(--sd-fg))]" : "text-foreground"}`}>
            {headline}
          </h2>
          <p className={`text-[15px] leading-[1.75] mb-16 max-w-md mx-auto relative z-10 font-light ${isDark ? "text-[hsl(var(--sd-fg)/0.35)]" : "text-muted-foreground"}`}>
            {description}
          </p>
          <div className="relative z-10 flex items-center justify-center gap-4">
            <span className="w-1 h-1 rounded-full bg-primary/30" />
            <a
              href="https://calendly.com/d/cvpp-rwv-v5j"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary group"
            >
              {t("cta.talkToUs")}
              <ArrowRight className="w-3 h-3" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
